import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimeKeeperEntryState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: TimeKeeperEntryState = {
  data: [],
  isLoading: false,
  error: null,
};

const timeKeeperEntriesSlice = createSlice({
  name: 'timeKeeperEntries',
  initialState,
  reducers: {
    setTimeKeeperEntries: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setTimeKeeperEntriesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setTimeKeeperEntriesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setTimeKeeperEntries, setTimeKeeperEntriesLoading, setTimeKeeperEntriesError } =
  timeKeeperEntriesSlice.actions;

export default timeKeeperEntriesSlice.reducer;
